<template>
    <kv-select-filter
        :name="name"
        :label="label"
        :current-value="currentValue"
        :removable="removable"
        :searchable="true"
        :options="selectOptions"
        @changed="$emit('changed', $event)"
        @remove="$emit('remove')"
    />
</template>

<script>
import keviApi from "./../../../keviApi";
import KvSelectFilter from "./kv-select-filter.vue";

export default {
    name: "filter-form",
    components: {
        "kv-select-filter": KvSelectFilter,
    },
    props: {
        name: {
            type: String,
            default: "forms",
        },
        label: {
            type: String,
            default: "",
        },
        currentValue: {
            type: [String, Number, Array],
            default: null,
        },
        removable: {
            type: Boolean,
            default: false,
        },
        options: {
            type: [Object, Array],
            default: () => ({}),
        },
    },
    data() {
        return {
            forms: [],
        };
    },
    computed: {
        selectOptions() {
            return {
                icon: "ui-file-02",
                options: this.forms.map((form) => ({
                    value: form.id,
                    label: form.name,
                })),
            };
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        getForms() {
            const options = keviApi.getOptions("forms");
            this.$http(options).then((response) => {
                if (response.status === 200) {
                    this.forms = (response.body || []).filter(
                        (form) => form && form.id != null,
                    );
                }
            });
        },
    },
    beforeMount() {
        this.getForms();
    },
};
</script>
